// Svgs.js - Contains only the SVG components used in ProjectPage.js
import React from 'react';

export const ActionIcon = ({ className = "", onClick, style }) => (
  <img
    src="/action.svg"
    alt="Actions"
    width="20"
    height="20"
    onClick={onClick}
    style={style}
    className={className}
  />
);

export const ArrowBackIcon = ({ className = "" }) => (
  <img src="/arrow-back.svg" alt="Back" className={className} />
);

export const FolderIconSvg = ({ className = "" }) => (
  <img src="/folder-icon-folder.svg" alt="Folder Icon" className={className} />
);

export const SearchIconSvg = ({ className = "" }) => (
  <img src="/search.svg" alt="Search" className={className} />
);

export const FilterIconSvg = ({ className = "" }) => (
  <img src="/filter-icon-first.svg" alt="Filter Icon" className={className} />
);

export const SortIconSvg = ({ className = "" }) => (
  <img src="/icons-size-icon.svg" alt="Sort Icon" className={className} />
);

export const UploadIconSvg = ({ className = "" }) => (
  <img src="/upload_white.svg" alt="Upload" className={className} />
);

export const ChatIconSvg = ({ className = "" }) => (
  <img src="/askaicontent.svg" alt="Ask Copilot" className={className} />
);

export const AddIconSvg = ({ className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" className={className}>
    <path d="M5.35714 7.14286H0.892857C0.639881 7.14286 0.427827 7.05729 0.256696 6.88616C0.0855655 6.71503 0 6.50298 0 6.25C0 5.99702 0.0855655 5.78497 0.256696 5.61384C0.427827 5.44271 0.639881 5.35714 0.892857 5.35714H5.35714V0.892857C5.35714 0.639881 5.44271 0.427827 5.61384 0.256696C5.78497 0.0855655 5.99702 0 6.25 0C6.50298 0 6.71503 0.0855655 6.88616 0.256696C7.05729 0.427827 7.14286 0.639881 7.14286 0.892857V5.35714H11.6071C11.8601 5.35714 12.0722 5.44271 12.2433 5.61384C12.4144 5.78497 12.5 5.99702 12.5 6.25C12.5 6.50298 12.4144 6.71503 12.2433 6.88616C12.0722 7.05729 11.8601 7.14286 11.6071 7.14286H7.14286V11.6071C7.14286 11.8601 7.05729 12.0722 6.88616 12.2433C6.71503 12.4144 6.50298 12.5 6.25 12.5C5.99702 12.5 5.78497 12.4144 5.61384 12.2433C5.44271 12.0722 5.35714 11.8601 5.35714 11.6071V7.14286Z" fill="currentColor"/>
  </svg>
);

export const DeleteIconSvg = ({ className = "", active = false }) => (
  <img
    src={active ? "/delete-active-contract.svg" : "/delete.svg"}
    alt="Delete"
    className={className}
  />
);

export const EditIconSvg = ({ className = "", active = false }) => (
  <img
    src={active ? "/edit-active-contract.svg" : "/edit.svg"}
    alt="Edit"
    className={className}
  />
);

export const DownloadIconSvg = ({ className = "", active = false }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color: active ? "#C95EBE" : "#000" }}
  >
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66675 6.66667L8.00008 10L11.3334 6.66667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10V2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIconSvg = ({ className = "" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15 5L5 15M5 5L15 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckIconSvg = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);


export const PromptIcons = [
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M1.66667 15C1.20833 15 0.815972 14.8368 0.489583 14.5104C0.163194 14.184 0 13.7917 0 13.3333V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H13.3333C13.7917 0 14.184 0.163194 14.5104 0.489583C14.8368 0.815972 15 1.20833 15 1.66667V13.3333C15 13.7917 14.8368 14.184 14.5104 14.5104C14.184 14.8368 13.7917 15 13.3333 15H1.66667ZM1.66667 13.3333H13.3333V1.66667H1.66667V13.3333ZM4.16667 11.6667H8.33333C8.56944 11.6667 8.76736 11.5868 8.92708 11.4271C9.08681 11.2674 9.16667 11.0694 9.16667 10.8333C9.16667 10.5972 9.08681 10.3993 8.92708 10.2396C8.76736 10.0799 8.56944 10 8.33333 10H4.16667C3.93056 10 3.73264 10.0799 3.57292 10.2396C3.41319 10.3993 3.33333 10.5972 3.33333 10.8333C3.33333 11.0694 3.41319 11.2674 3.57292 11.4271C3.73264 11.5868 3.93056 11.6667 4.16667 11.6667ZM4.16667 8.33333H10.8333C11.0694 8.33333 11.2674 8.25347 11.4271 8.09375C11.5868 7.93403 11.6667 7.73611 11.6667 7.5C11.6667 7.26389 11.5868 7.06597 11.4271 6.90625C11.2674 6.74653 11.0694 6.66667 10.8333 6.66667H4.16667C3.93056 6.66667 3.73264 6.74653 3.57292 6.90625C3.41319 7.06597 3.33333 7.26389 3.33333 7.5C3.33333 7.73611 3.41319 7.93403 3.57292 8.09375C3.73264 8.25347 3.93056 8.33333 4.16667 8.33333ZM4.16667 5H10.8333C11.0694 5 11.2674 4.92014 11.4271 4.76042C11.5868 4.60069 11.6667 4.40278 11.6667 4.16667C11.6667 3.93056 11.5868 3.73264 11.4271 3.57292C11.2674 3.41319 11.0694 3.33333 10.8333 3.33333H4.16667C3.93056 3.33333 3.73264 3.41319 3.57292 3.57292C3.41319 3.73264 3.33333 3.93056 3.33333 4.16667C3.33333 4.40278 3.41319 4.60069 3.57292 4.76042C3.73264 4.92014 3.93056 5 4.16667 5Z"
      fill="#BB42AE"
    />
  </svg>,
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
  >
    <path
      d="M6.66667 14.7917C8.11111 14.3333 9.30556 13.4167 10.25 12.0417C11.1944 10.6667 11.6667 9.13889 11.6667 7.45833V3.52083L6.66667 1.64583L1.66667 3.52083V7.45833C1.66667 9.13889 2.13889 10.6667 3.08333 12.0417C4.02778 13.4167 5.22222 14.3333 6.66667 14.7917ZM6.66667 12.375C6.90278 12.375 7.10764 12.2882 7.28125 12.1146C7.45486 11.941 7.54167 11.7361 7.54167 11.5C7.54167 11.2639 7.45486 11.059 7.28125 10.8854C7.10764 10.7118 6.90278 10.625 6.66667 10.625C6.43056 10.625 6.22569 10.7118 6.05208 10.8854C5.87847 11.059 5.79167 11.2639 5.79167 11.5C5.79167 11.7361 5.87847 11.941 6.05208 12.1146C6.22569 12.2882 6.43056 12.375 6.66667 12.375ZM6.6875 9.79167C6.85417 9.79167 7.00347 9.72917 7.13542 9.60417C7.26736 9.47917 7.33333 9.33333 7.33333 9.16667C7.34722 9.06944 7.36806 8.9757 7.39583 8.88542C7.42361 8.79514 7.46528 8.70833 7.52083 8.625C7.61806 8.48611 7.72569 8.36111 7.84375 8.25C7.96181 8.13889 8.07639 8.02778 8.1875 7.91667C8.42361 7.68056 8.62847 7.41667 8.80208 7.125C8.97569 6.83333 9.0625 6.51389 9.0625 6.16667C9.0625 5.54167 8.82292 5.03125 8.34375 4.63542C7.86458 4.23958 7.30556 4.04167 6.66667 4.04167C6.22222 4.04167 5.8125 4.14583 5.4375 4.35417C5.0625 4.5625 4.76389 4.85417 4.54167 5.22917C4.45833 5.38194 4.44792 5.53472 4.51042 5.6875C4.57292 5.84028 4.6875 5.95139 4.85417 6.02083C5.00694 6.09028 5.15972 6.08681 5.3125 6.01042C5.46528 5.93403 5.59722 5.83333 5.70833 5.70833C5.83333 5.55556 5.97569 5.44097 6.13542 5.36458C6.29514 5.28819 6.47222 5.25 6.66667 5.25C6.97222 5.25 7.23958 5.34028 7.46875 5.52083C7.69792 5.70139 7.8125 5.93056 7.8125 6.20833C7.8125 6.44445 7.73958 6.6632 7.59375 6.86458C7.44792 7.06597 7.28472 7.25 7.10417 7.41667C6.95139 7.56945 6.79861 7.71875 6.64583 7.86458C6.49306 8.01042 6.36111 8.17361 6.25 8.35417C6.18056 8.46528 6.13194 8.59028 6.10417 8.72917C6.07639 8.86806 6.0625 9.00695 6.0625 9.14583C6.0625 9.32639 6.12153 9.47917 6.23958 9.60417C6.35764 9.72917 6.50694 9.79167 6.6875 9.79167ZM6.66667 16.4583C6.56944 16.4583 6.47917 16.4514 6.39583 16.4375C6.3125 16.4236 6.22917 16.4028 6.14583 16.375C4.27083 15.75 2.77778 14.5938 1.66667 12.9063C0.555556 11.2188 0 9.40278 0 7.45833V3.52083C0 3.17361 0.100694 2.86111 0.302083 2.58333C0.503472 2.30556 0.763889 2.10417 1.08333 1.97917L6.08333 0.104167C6.27778 0.0347222 6.47222 0 6.66667 0C6.86111 0 7.05556 0.0347222 7.25 0.104167L12.25 1.97917C12.5694 2.10417 12.8299 2.30556 13.0312 2.58333C13.2326 2.86111 13.3333 3.17361 13.3333 3.52083V7.45833C13.3333 9.40278 12.7778 11.2188 11.6667 12.9063C10.5556 14.5938 9.0625 15.75 7.1875 16.375C7.10417 16.4028 7.02083 16.4236 6.9375 16.4375C6.85417 16.4514 6.76389 16.4583 6.66667 16.4583Z"
      fill="#BB42AE"
    />
  </svg>,
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      d="M2.5 16.6667C1.80556 16.6667 1.21528 16.4236 0.729167 15.9375C0.243056 15.4514 0 14.8611 0 14.1667V11.6667H2.5V0H15V14.1667C15 14.8611 14.7569 15.4514 14.2708 15.9375C13.7847 16.4236 13.1944 16.6667 12.5 16.6667H2.5ZM12.5 15C12.7361 15 12.934 14.9201 13.0938 14.7604C13.2535 14.6007 13.3333 14.4028 13.3333 14.1667V1.66667H4.16667V11.6667H11.6667V14.1667C11.6667 14.4028 11.7465 14.6007 11.9062 14.7604C12.066 14.9201 12.2639 15 12.5 15ZM5 5.83333V4.16667H12.5V5.83333H5ZM5 8.33333V6.66667H12.5V8.33333H5ZM2.5 15H10V13.3333H1.66667V14.1667C1.66667 14.4028 1.74653 14.6007 1.90625 14.7604C2.06597 14.9201 2.26389 15 2.5 15ZM2.5 15H1.66667H10H2.5Z"
      fill="#BB42AE"
    />
  </svg>,
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      d="M1.66667 1.66667V6.6875V6.66667V15V1.66667ZM1.66667 16.6667C1.20833 16.6667 0.815972 16.5035 0.489583 16.1771C0.163194 15.8507 0 15.4583 0 15V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H7.64583C7.86806 0 8.07986 0.0416667 8.28125 0.125C8.48264 0.208333 8.65972 0.326389 8.8125 0.479167L12.8542 4.52083C13.0069 4.67361 13.125 4.85069 13.2083 5.05208C13.2917 5.25347 13.3333 5.46528 13.3333 5.6875V6.27083C13.3333 6.50694 13.2535 6.70139 13.0938 6.85417C12.934 7.00694 12.7361 7.08333 12.5 7.08333C12.2639 7.08333 12.066 7.00347 11.9062 6.84375C11.7465 6.68403 11.6667 6.48611 11.6667 6.25V5.83333H8.33333C8.09722 5.83333 7.89931 5.75347 7.73958 5.59375C7.57986 5.43403 7.5 5.23611 7.5 5V1.66667H1.66667V15H6.25C6.48611 15 6.68403 15.0799 6.84375 15.2396C7.00347 15.3993 7.08333 15.5972 7.08333 15.8333C7.08333 16.0694 7.00347 16.2674 6.84375 16.4271C6.68403 16.5868 6.48611 16.6667 6.25 16.6667H1.66667ZM11.25 14.1667C11.8333 14.1667 12.3264 13.9653 12.7292 13.5625C13.1319 13.1597 13.3333 12.6667 13.3333 12.0833C13.3333 11.5 13.1319 11.0069 12.7292 10.6042C12.3264 10.2014 11.8333 10 11.25 10C10.6667 10 10.1736 10.2014 9.77083 10.6042C9.36806 11.0069 9.16667 11.5 9.16667 12.0833C9.16667 12.6667 9.36806 13.1597 9.77083 13.5625C10.1736 13.9653 10.6667 14.1667 11.25 14.1667ZM16.0833 16.9167C15.9306 17.0694 15.7361 17.1458 15.5 17.1458C15.2639 17.1458 15.0694 17.0694 14.9167 16.9167L13.25 15.25C12.9583 15.4444 12.6424 15.5903 12.3021 15.6875C11.9618 15.7847 11.6111 15.8333 11.25 15.8333C10.2083 15.8333 9.32292 15.4688 8.59375 14.7396C7.86458 14.0104 7.5 13.125 7.5 12.0833C7.5 11.0417 7.86458 10.1562 8.59375 9.42708C9.32292 8.69792 10.2083 8.33333 11.25 8.33333C12.2917 8.33333 13.1771 8.69792 13.9062 9.42708C14.6354 10.1562 15 11.0417 15 12.0833C15 12.4444 14.9514 12.7951 14.8542 13.1354C14.7569 13.4757 14.6111 13.7917 14.4167 14.0833L16.0833 15.75C16.2361 15.9028 16.3125 16.0972 16.3125 16.3333C16.3125 16.5694 16.2361 16.7639 16.0833 16.9167Z"
      fill="#BB42AE"
    />
  </svg>,
];

export const BotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.19778 8.97151C7.2067 8.3679 6.71008 7.85879 6.10602 7.85166C5.46407 7.84364 4.95987 8.32733 4.95318 8.95724C4.94694 9.55506 5.42974 10.0405 6.04094 10.0512C6.66595 10.0624 7.18931 9.57423 7.19823 8.97151H7.19778Z"
      fill="#C95EBE"
    />
    <path
      d="M9.93635 7.85162C9.29885 7.84538 8.79465 8.33754 8.79688 8.96478C8.79867 9.55636 9.29529 10.0521 9.88998 10.0561C10.5043 10.0601 11.0326 9.5568 11.0361 8.96344C11.0401 8.36652 10.5364 7.85742 9.93635 7.85162Z"
      fill="#C95EBE"
    />
    <path
      d="M8.73885 11.658C8.6274 11.7356 8.36884 11.8265 8.00863 11.8265C7.64843 11.8265 7.38986 11.736 7.27841 11.658C7.07647 11.5176 6.79829 11.5675 6.65786 11.7694C6.51743 11.9714 6.56736 12.2496 6.76931 12.39C7.06889 12.5986 7.52093 12.7181 8.00863 12.7181C8.49634 12.7181 8.94838 12.5986 9.24795 12.39C9.4499 12.2496 9.49983 11.9718 9.3594 11.7694C9.21898 11.567 8.9408 11.5176 8.73885 11.658Z"
      fill="#C95EBE"
    />
    <path
      d="M7.56714 2.13582V3.87845C7.56714 4.12453 7.76685 4.32425 8.01294 4.32425C8.25902 4.32425 8.45873 4.12453 8.45873 3.87845V2.13582C8.85238 1.96375 9.12743 1.57144 9.12743 1.1145C9.12743 0.498849 8.62858 0 8.01294 0C7.39729 0 6.89844 0.498849 6.89844 1.1145C6.89844 1.57144 7.1735 1.96419 7.56714 2.13582Z"
      fill="#C95EBE"
    />
    <path
      d="M14.0965 6.83014C13.9342 6.78735 13.8548 6.70621 13.7893 6.56489C12.8598 4.56593 11.3147 3.30833 9.18865 2.74974C9.15121 2.73994 9.11554 2.73147 9.08166 2.72656C9.02727 2.77605 8.96976 2.82196 8.90869 2.86387V3.8745C8.90869 4.36621 8.50881 4.76609 8.01709 4.76609C7.52538 4.76609 7.12549 4.36621 7.12549 3.8745V2.86387C7.06799 2.82464 7.0136 2.7814 6.96189 2.73548C6.92533 2.73637 6.88565 2.7435 6.84107 2.75509C4.72219 3.29852 3.20424 4.56771 2.26762 6.53815C2.19273 6.69551 2.1214 6.79849 1.91767 6.84708C0.670321 7.14577 -0.200324 8.3521 0.0399613 9.6467C0.226305 10.652 1.12459 11.5307 2.17846 11.7326C2.32245 11.7602 2.40894 11.812 2.47358 11.9528C2.77137 12.6015 3.198 13.1618 3.70711 13.658C6.44788 16.3306 11.4542 15.9512 13.4634 12.1084C13.5824 11.8811 13.693 11.7023 13.9837 11.676C14.1544 11.6604 14.3252 11.5743 14.483 11.4945C15.404 11.0287 15.9505 10.2864 15.9978 9.24905C16.0482 8.14124 15.2324 7.13151 14.0969 6.83059L14.0965 6.83014ZM1.77858 10.36C1.34927 10.1919 1.01983 9.69173 1.03454 9.196C1.0497 8.68957 1.41436 8.22193 1.77858 8.13767V10.36ZM13.1331 9.35069C13.0034 11.3167 12.0284 12.8128 10.2434 13.6914C8.40538 14.5964 6.6048 14.4038 4.97273 13.2046C3.48733 12.1133 2.7424 10.5882 2.87703 8.7297C3.02147 6.73608 4.09673 5.32513 5.82866 4.38627C6.00253 4.29176 6.18887 4.22044 6.3926 4.12771C6.54595 4.58465 6.62442 4.82316 6.7693 5.25692C6.94762 5.79188 7.30426 5.84047 7.4059 5.84047C8.61446 5.84047 9.70221 5.42008 10.7226 4.80666C10.8421 4.73489 10.9126 4.74336 11.0142 4.8236C12.4787 5.97867 13.2566 7.48725 13.1335 9.35069H13.1331ZM14.1874 10.3515C14.3666 9.60658 14.3617 8.8884 14.2378 8.16442C14.6314 8.29326 14.9172 8.68645 14.9448 9.12512C14.9805 9.68772 14.7429 10.0885 14.1874 10.352V10.3515Z"
      fill="#C95EBE"
    />
  </svg>
);

export const SendIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M0.109382 3.34736C-0.476783 1.35482 1.39046 -0.512134 3.38463 0.128083C7.16322 1.34117 10.7695 3.04252 14.1132 5.18947C14.2064 5.24932 14.3161 5.31594 14.4359 5.38861C14.8104 5.61595 15.2826 5.9026 15.6518 6.22677C16.1918 6.701 16.6673 7.37132 16.6673 8.33518C16.6673 9.29904 16.1918 9.96937 15.6518 10.4436C15.2826 10.7678 14.8104 11.0544 14.4359 11.2817C14.3161 11.3544 14.2064 11.421 14.1132 11.4809C10.7695 13.6278 7.16322 15.3292 3.38463 16.5423C1.39046 17.1825 -0.476783 15.3155 0.109381 13.323L1.15559 9.76665C1.25991 9.41202 1.58539 9.1685 1.95505 9.1685H6.52971C6.98995 9.1685 7.36304 8.7954 7.36304 8.33517C7.36304 7.87493 6.98995 7.50183 6.52971 7.50183H1.95504C1.58538 7.50183 1.2599 7.25831 1.15558 6.90368L0.109382 3.34736Z"
      fill="#EAF7FF"
    />
  </svg>
);

export const ScrollDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14M19 12l-7 7-7-7" />
  </svg>
);


export const CloseIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export const RemoveIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

export const UploadIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M4 14.899V20c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-5.101M12 3v13.5M7.5 7.5l4.5-4.5 4.5 4.5" />
  </svg>
);

export const CheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
      fill="#22C55E"
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
      fill="#EF4444"
    />
  </svg>
);